import Flex from "../../shared/components/Flex";
import Text from "../../shared/components/Text";

const EmptyState = () => {
    return (
        <Flex alignItems="center" justifyContent="center" height="100%" gap={10} flexDirection="column"
            style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#88888a",
                minHeight: "220px"
            }}
        >
            <img src="/images/img_folder.png" alt="folder"/>
            <Text size={16} weight={"semibold"}>데이터가 없습니다.</Text>
        </Flex>
    )
}

export default EmptyState;